/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivContractControllerCreatePayloadGen,
  MrfiktivContractControllerGetParamsGen,
  MrfiktivContractControllerUpdatePayloadGen,
  MrfiktivContractViewModelGen,
  MrfiktivCustomerContractViewModelGen,
  MrfiktivInsuranceContractViewModelGen,
  MrfiktivMultipleIdsDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivWorkshopContractViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Contract<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags contract
   * @name ContractControllerCreate
   * @summary (Contract - CREATE) Create a Contract
   * @request POST:/partner/{partnerId}/contract
   * @secure
   * @response `200` `(MrfiktivContractViewModelGen | MrfiktivWorkshopContractViewModelGen | MrfiktivInsuranceContractViewModelGen | MrfiktivCustomerContractViewModelGen)`
   */
  contractControllerCreate = (
    partnerId: string,
    data: MrfiktivContractControllerCreatePayloadGen,
    params: RequestParams = {}
  ) =>
    this.http.request<
      | MrfiktivContractViewModelGen
      | MrfiktivWorkshopContractViewModelGen
      | MrfiktivInsuranceContractViewModelGen
      | MrfiktivCustomerContractViewModelGen,
      any
    >({
      path: `/partner/${partnerId}/contract`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags contract
   * @name ContractControllerGet
   * @summary (Contract - READ) Get all companies
   * @request GET:/partner/{partnerId}/contract
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: ((MrfiktivContractViewModelGen | MrfiktivWorkshopContractViewModelGen | MrfiktivInsuranceContractViewModelGen | MrfiktivCustomerContractViewModelGen))[] })`
   */
  contractControllerGet = (
    { partnerId, ...query }: MrfiktivContractControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<
      MrfiktivPageViewModelGen & {
        data?: (
          | MrfiktivContractViewModelGen
          | MrfiktivWorkshopContractViewModelGen
          | MrfiktivInsuranceContractViewModelGen
          | MrfiktivCustomerContractViewModelGen
        )[];
      },
      any
    >({
      path: `/partner/${partnerId}/contract`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags contract
   * @name ContractControllerGetOne
   * @summary (Contract - READ) Get a contract
   * @request GET:/partner/{partnerId}/contract/{contractId}
   * @secure
   * @response `200` `(MrfiktivContractViewModelGen | MrfiktivWorkshopContractViewModelGen | MrfiktivInsuranceContractViewModelGen | MrfiktivCustomerContractViewModelGen)`
   */
  contractControllerGetOne = (partnerId: string, contractId: string, params: RequestParams = {}) =>
    this.http.request<
      | MrfiktivContractViewModelGen
      | MrfiktivWorkshopContractViewModelGen
      | MrfiktivInsuranceContractViewModelGen
      | MrfiktivCustomerContractViewModelGen,
      any
    >({
      path: `/partner/${partnerId}/contract/${contractId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags contract
   * @name ContractControllerUpdate
   * @summary (Contract - UPDATE) Updates a contract
   * @request PATCH:/partner/{partnerId}/contract/{contractId}
   * @secure
   * @response `200` `(MrfiktivContractViewModelGen | MrfiktivWorkshopContractViewModelGen | MrfiktivInsuranceContractViewModelGen | MrfiktivCustomerContractViewModelGen)`
   */
  contractControllerUpdate = (
    partnerId: string,
    contractId: string,
    data: MrfiktivContractControllerUpdatePayloadGen,
    params: RequestParams = {}
  ) =>
    this.http.request<
      | MrfiktivContractViewModelGen
      | MrfiktivWorkshopContractViewModelGen
      | MrfiktivInsuranceContractViewModelGen
      | MrfiktivCustomerContractViewModelGen,
      any
    >({
      path: `/partner/${partnerId}/contract/${contractId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags contract
   * @name ContractControllerDelete
   * @summary (Contract - DELETE) Deletes a contract
   * @request DELETE:/partner/{partnerId}/contract/{contractId}
   * @secure
   * @response `200` `(MrfiktivContractViewModelGen | MrfiktivWorkshopContractViewModelGen | MrfiktivInsuranceContractViewModelGen | MrfiktivCustomerContractViewModelGen)`
   */
  contractControllerDelete = (partnerId: string, contractId: string, params: RequestParams = {}) =>
    this.http.request<
      | MrfiktivContractViewModelGen
      | MrfiktivWorkshopContractViewModelGen
      | MrfiktivInsuranceContractViewModelGen
      | MrfiktivCustomerContractViewModelGen,
      any
    >({
      path: `/partner/${partnerId}/contract/${contractId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags contract
   * @name ContractControllerGetMany
   * @summary (Contract - READ) Get many contracts
   * @request POST:/partner/{partnerId}/contract/getByIds
   * @secure
   * @response `200` `((MrfiktivContractViewModelGen | MrfiktivWorkshopContractViewModelGen | MrfiktivInsuranceContractViewModelGen | MrfiktivCustomerContractViewModelGen))[]`
   */
  contractControllerGetMany = (partnerId: string, data: MrfiktivMultipleIdsDtoGen, params: RequestParams = {}) =>
    this.http.request<
      (
        | MrfiktivContractViewModelGen
        | MrfiktivWorkshopContractViewModelGen
        | MrfiktivInsuranceContractViewModelGen
        | MrfiktivCustomerContractViewModelGen
      )[],
      any
    >({
      path: `/partner/${partnerId}/contract/getByIds`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags contract
   * @name ContractControllerGetManyByCompanyIds
   * @summary (Contract - READ) Get many contracts by company ids
   * @request POST:/partner/{partnerId}/contract/getByCompanyIds
   * @secure
   * @response `200` `((MrfiktivContractViewModelGen | MrfiktivWorkshopContractViewModelGen | MrfiktivInsuranceContractViewModelGen | MrfiktivCustomerContractViewModelGen))[]`
   */
  contractControllerGetManyByCompanyIds = (
    partnerId: string,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<
      (
        | MrfiktivContractViewModelGen
        | MrfiktivWorkshopContractViewModelGen
        | MrfiktivInsuranceContractViewModelGen
        | MrfiktivCustomerContractViewModelGen
      )[],
      any
    >({
      path: `/partner/${partnerId}/contract/getByCompanyIds`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags contract
   * @name ContractControllerGetManyByRefIds
   * @summary (Contract - READ) Get many contracts by reference ids
   * @request POST:/partner/{partnerId}/contract/getByRefIds
   * @secure
   * @response `200` `((MrfiktivContractViewModelGen | MrfiktivWorkshopContractViewModelGen | MrfiktivInsuranceContractViewModelGen | MrfiktivCustomerContractViewModelGen))[]`
   */
  contractControllerGetManyByRefIds = (
    partnerId: string,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<
      (
        | MrfiktivContractViewModelGen
        | MrfiktivWorkshopContractViewModelGen
        | MrfiktivInsuranceContractViewModelGen
        | MrfiktivCustomerContractViewModelGen
      )[],
      any
    >({
      path: `/partner/${partnerId}/contract/getByRefIds`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
